import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';
import { Router } from '@angular/router';
import { SnackbarService } from '../_service/message-service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, readonly router: Router, private toastr: SnackbarService, readonly translate: TranslateService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => this.handleError(err))
        )
    }

    handleError(errorRes: HttpErrorResponse) {
        let errorObj = null;
        if (errorRes instanceof HttpErrorResponse) {
            let errMsg = '';
            if (errorRes.error instanceof Object && errorRes.error.status_message) {
                errMsg = errorRes.error.status_message;
            }
            else if (errorRes.error instanceof Object && errorRes.error.errors) {
                errMsg = `${errorRes.error.errors}`;
            }
            else if (errorRes.error instanceof Object && errorRes.error.message) {
                errMsg = `${errorRes.error.message}`;
            } else if (errorRes.message) {
                errMsg = `${errorRes.message}`;
            } else {
                errMsg = 'HTTP status ${errorRes.status}: Unknown Error';
            }

            errorObj = {
                success: false,
                message: errMsg,
                status: errorRes.status
            }

            let errorStatus = parseInt(errorObj.status);
            switch (true) {
                case errorStatus == 401 || errorStatus == 403:
                    // this.authenticationService.logout();
                    this.router.navigate(['/']);
                    this.toastr.error(this.translate.instant('unAuthorized'));
                    break;

                default:
                    break;
            }
        } else {
            errorObj = errorRes;
        }

        return throwError(errorObj);
    }
}